import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveInventoryLevelLedgerView = {
  name: "saveInventoryLevelLedgerView" as const,
  input: z.object({ view: viewSchemas["inventory-level-ledger"] }),
  output: z.object({}),
};
